import type { WorkingAnswerFeedback } from './workingStepFeedback.ts';

export type MarkVerdict = 'correct' | 'partial' | 'incorrect' | 'unanswered';

export const verdictFromMarks = (awarded: number, maxMarks: number): MarkVerdict => {
  if (!Number.isFinite(awarded) || awarded <= 0) return 'incorrect';
  if (maxMarks <= 0) return 'correct';
  if (awarded >= maxMarks) return 'correct';
  return 'partial';
};

export const formatMarkFraction = (awarded: number, maxMarks: number): string => {
  const fmt = (n: number) => (Number.isInteger(n) ? String(n) : n.toFixed(1));
  return `${fmt(awarded)} / ${fmt(maxMarks)} marks`;
};

export const verdictLabel = (verdict: MarkVerdict): string => {
  switch (verdict) {
    case 'correct':
      return 'Correct';
    case 'partial':
      return 'Partially correct';
    case 'incorrect':
      return 'Incorrect';
    default:
      return '';
  }
};

export const verdictColor = (
  verdict: MarkVerdict,
): 'success.main' | 'warning.main' | 'error.main' | 'text.secondary' => {
  switch (verdict) {
    case 'correct':
      return 'success.main';
    case 'partial':
      return 'warning.main';
    case 'incorrect':
      return 'error.main';
    default:
      return 'text.secondary';
  }
};

export type PracticeMarkResult = {
  awarded: number;
  max: number;
  feedback: string;
  verdict: MarkVerdict;
  partFeedback?: WorkingAnswerFeedback;
  model?: string;
  tier?: string;
};
